(function(){
    'use strict'

    angular
    .module('app.archivoAsociacion')
    .controller('ArchivoAsociacion', ArchivoAsociacion);

    ArchivoAsociacion.$inject = ['$scope', '$animationsSrv', 'ArchivoAsociacionService', 'logger', '$location', 'UserInfoService', 'TiposPlanillaService', 'CalendarizacionesService'];

    function ArchivoAsociacion($scope, $animationsSrv, ArchivoAsociacionService, logger, $location, UserInfoService, TiposPlanillaService, CalendarizacionesService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.tiposPlanilla = [];
        vm.planillas = [];
        vm.title = 'ArchivoAsociacion';

        vm.archivoAsociacion = {
            tipoPlanillaId: -1,
            planillaId: -1
        };

        vm.goToEdit = function(){
            
            var path = '/datos-archivo-asociacion/' + vm.archivoAsociacion.tipoPlanillaId + '/' + vm.archivoAsociacion.planillaId;

            $location.path(path);
            
        };

        getTiposPlanilla();

        function getTiposPlanilla(){
            var promise = TiposPlanillaService.getAllForCalendarizacion(UserInfoService.getCompaniaId())
            .then(function(tiposPlanilla){
                tiposPlanilla.forEach(tipo => {
                    tipo.fechaInicio = moment(tipo.fechaInicio).toDate();
                    tipo.fechaFinal = moment(tipo.fechaFinal).toDate();
                });
                vm.tiposPlanilla = tiposPlanilla;
            })
            .catch(function(error){
                $logger.error('Error al obtener los tipos de planilla.');
            }); 
            
            return promise;
        };

        function getAllCalendarizaciones(){

            var promise = CalendarizacionesService.getAllAbiertasProcesando(UserInfoService.getCompaniaId(), vm.tipoPlanilla.id);

            promise
            .then(function(calendarizaciones){
                calendarizaciones.forEach(calendarizacion => {
                    calendarizacion.fechaInicio = moment(calendarizacion.fechaInicio).toDate();
                    calendarizacion.fechaFinal = moment(calendarizacion.fechaFinal).toDate();
                });
                vm.planillas = calendarizaciones;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener las Planillas.');
                        break;
                }
                
            });
        };

        function validateTipoPlanilla(){
            if(vm.archivoAsociacion.tipoPlanillaId == -1){
                $scope.archivoAsociacionForm.tipoPlanillaId.$setValidity("different", false);
            }
            else{
                $scope.archivoAsociacionForm.tipoPlanillaId.$setValidity("different", true);
            }
        };

        function validatePlanilla(){
            if(vm.archivoAsociacion.planillaId == -1){
                $scope.archivoAsociacionForm.planillaId.$setValidity("different", false);
            }
            else{
                $scope.archivoAsociacionForm.planillaId.$setValidity("different", true);
            }
        };

        function doFormValidations(){
            validateTipoPlanilla();
            validatePlanilla();
        };

        vm.uploadFile = function(){
            var file = $scope.myFile;
            
            $scope.submitted = true;
            doFormValidations();

            if(!$scope.archivoAsociacionForm.$valid){
                return;
            }

            if(file === undefined){
                logger.warning('No se ha seleccionado un archivo.');
                return;
            }
            if(file.name.indexOf('.csv') === -1){
                logger.warning('El archivo es incorrecto, seleccione un csv.');
                return;
            }

            var promise = ArchivoAsociacionService.uploadFile(file, vm.planilla.id);

            promise.then(function (response) {
                logger.success('Archivo Cargado exitosamente.');
                vm.goToEdit();
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un error al cargar el archivo.');
                        break;
                }
                
            });

        };

        vm.tipoPlanillaChange = function(tipoPlanillaId){
            if(tipoPlanillaId !== -1){
                $scope.archivoAsociacionForm.tipoPlanillaId.$setValidity("different", true);
                vm.tipoPlanilla = vm.tiposPlanilla.find(function(tipo) {
                    return tipo.id == tipoPlanillaId;
                });
                getAllCalendarizaciones();          
            }
            else{
                if(tipoPlanillaId != null){
                    vm.planillas = [];
                    $scope.archivoAsociacionForm.tipoPlanillaId.$setValidity("different", false);                    
                }
            }
        };

        vm.planillaChange = function(planillaId){
            if(planillaId !== -1){
                $scope.archivoAsociacionForm.planillaId.$setValidity("different", true);
                vm.planilla = vm.planillas.find(function(p) {
                    return p.id == planillaId;
                });
            }
            else{
                if(planillaId != null){
                    $scope.archivoAsociacionForm.planillaId.$setValidity("different", false);                    
                }
            }
        };

    }
})();